module.exports = __webpack_public_path__ + "dist/fonts/roboto/Roboto-ThinItalic-webfont.woff";


//////////////////
// WEBPACK FOOTER
// ./dist/fonts/roboto/Roboto-ThinItalic-webfont.woff
// module id = 1625
// module chunks = 0